/**
 * Valid status transitions map
 * Key: current status, Value: array of valid next statuses
 *
 * Current rules (internal users workflow):
 * 1. DRAFT → IN_REVIEW, ACTIVE, PUBLISHED, or ARCHIVED
 * 2. IN_REVIEW → PUBLISHED, ACTIVE, ARCHIVED, or DRAFT (revert if PR rejected)
 * 3. PUBLISHED → ACTIVE or TERMINATED (must terminate before archiving)
 * 4. ACTIVE → PAUSED, COMPLETED, or TERMINATED
 * 5. PAUSED → ACTIVE, TERMINATED, or COMPLETED
 * 6. DRAINING → COMPLETED or TERMINATED (can't be paused). Only beaker moves a
 *    switchback into DRAINING, so no status here lists it as a target.
 * 7. TERMINATED/COMPLETED can only transition to ARCHIVED
 * 8. ARCHIVED is fully terminal, no transitions allowed
 */
const VALID_MADHIVE_TRANSITIONS = {
    DRAFT: ["IN_REVIEW", "ACTIVE", "PUBLISHED", "ARCHIVED"],
    IN_REVIEW: ["PUBLISHED", "ACTIVE", "ARCHIVED", "DRAFT"],
    PUBLISHED: ["ACTIVE", "TERMINATED"],
    ACTIVE: ["PAUSED", "COMPLETED", "TERMINATED"],
    PAUSED: ["ACTIVE", "TERMINATED", "COMPLETED"],
    DRAINING: ["COMPLETED", "TERMINATED"],
    TERMINATED: ["ARCHIVED"],
    COMPLETED: ["ARCHIVED"],
    ARCHIVED: [] // Terminal state, no transitions allowed
};
/**
 * Checks if a status transition is valid
 *
 * @param fromStatus - Current status
 * @param toStatus - Desired status
 * @returns true if transition is valid, false otherwise
 */
export function isValidStatusTransition(fromStatus, toStatus) {
    const allowedTransitions = VALID_MADHIVE_TRANSITIONS[fromStatus];
    return allowedTransitions.includes(toStatus);
}
/**
 * Gets all valid next statuses from the current status
 *
 * @param currentStatus - Current experiment status
 * @returns Array of valid next statuses
 */
export function getValidNextStatuses(currentStatus) {
    return VALID_MADHIVE_TRANSITIONS[currentStatus];
}
/**
 * Whether the experiment is scoped to an advertiser rather than internal/global.
 *
 * @param experiment - Experiment to check
 * @returns true if the experiment has an advertiserId
 */
export function isAdvertiserFacing(experiment) {
    return !!experiment.advertiserId;
}
//# sourceMappingURL=experiments.js.map